import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { AdOrder } from '@/api/types/ads.types';
import { QUERY } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { omitEmptyQueryValues } from '@/utils/helpers';

export function useOrderChange() {
  const router = useRouter();

  const handleChangeOrder = useCallback(
    (newOrder: AdOrder) => {
      const { pathname, query } = router;

      router.push({
        pathname,
        query: omitEmptyQueryValues({
          ...query,
          order: newOrder.toLowerCase(),
          [QUERY.keywordsSource]: KeywordsSource.Typewritten,
        }),
      });
    },
    [router]
  );

  return handleChangeOrder;
}
